import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { IData } from '../../interfaces/data.interface';
import constants from 'src/config/constants';
import { DataValues } from 'src/app/utils/enums/data-values';
import { CompanyConfigService } from '../../services/company-config.service';

@Component({
  selector: 'custom-base',
  templateUrl: './custom-base.component.html',
  styleUrls: ['./custom-base.component.css']
})
export class CustomBaseComponent implements OnInit   {
  constructor(
    private readonly _companyConfigService: CompanyConfigService
  ){}
  isLoading: boolean = false;
  whatsAppNumber: string = '';
  whatsAppMessage: string = '';
  companyName: string = '';
  isDataReady: boolean = false;
  whatsappUrl: string = '';
  whatsAppHoverMessage: string = constants.WHATSAPP_BUTTON_HOVER_MESSAGE;
  logoImage: string = '';
  primaryColorHexadecimal: string = '';
  secondaryColorHexadecimal: string = '';
  dataInfo: IData[] = [];

  ngOnInit(): void {
    const company =  this._companyConfigService.getCompany();
    if (!company) {
      return;
    }

    this.whatsAppNumber = company.whatsAppNumber;
    this.whatsAppMessage = company.whatsAppMessage;
    this.companyName = company.companyName;
    this.logoImage = company.companyLogoImage;
    this.primaryColorHexadecimal = `#${company.primaryColorInfo.hexadecimal}`;
    this.secondaryColorHexadecimal = `#${company.secondaryColorInfo.hexadecimal}`;
    this.dataInfo = company.dataInfo;
    this.whatsappUrl = `${constants.whatsappLink}/+${this.whatsAppNumber}?text=${this.whatsAppMessage}`;
    this.isDataReady = true;
  }
}
